import { GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { Storage, LocalStorage } from "@swiggy-private/core-ui";

// constants
import { CARD_BRAND } from "@payment-client/constants/Card";

// interfaces
import { CardBrandDetails, ProceedNewCardDetails } from "@swiggy-private/payment-types";

export const removeCardFingerPrint = (): void => {
    try {
        const sessionHeaders = Storage.getItem<{ [key: string]: string }>("headers");
        const localHeaders = LocalStorage.getItem<{ [key: string]: string }>("auth_headers");

        if (sessionHeaders != null && sessionHeaders["card-fingerprint"] != null) {
            delete sessionHeaders["card-fingerprint"];
            Storage.setItem<{ [key: string]: string }>("headers", sessionHeaders);
        }

        if (localHeaders != null && localHeaders["card-fingerprint"] != null) {
            delete localHeaders["card-fingerprint"];
            LocalStorage.setItem<{ [key: string]: string }>("auth_headers", localHeaders);
        }

        GlobalHeaderState.removeHeader(SwgyHeaderKeysList.cardFingerprint);
    } catch {
        console.log("unable to remove card fingerprint");
    }
};

export const canSecureCard = (
    cardDetails: ProceedNewCardDetails,
    cardBrand: CardBrandDetails["cardBrand"],
): boolean => {
    // Since For Sodexo we get Tokenization Support as False but it gets tokenized by default
    if (cardBrand?.toUpperCase() === CARD_BRAND.SODEXO) {
        return true;
    }
    return !!(cardDetails.tokenizeSupport && cardDetails.saveCard);
};
